import React, { useState } from 'react';
import styles from './AiPlanBubble.module.css';

/**
 * AI 여행 계획 카드 버블 (채팅 메시지용)
 * @param {Object} props
 * @param {Object} props.planData - 여행 계획 데이터 (title, schedule, description)
 * @param {string} props.senderName - 생성한 사람 이름
 * @param {function} props.onViewDetail - 상세 보기 클릭 시 콜백
 */
const AiPlanBubble = ({ planData, senderName, onViewDetail }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!planData) return null;

    const { title, schedule = [], description } = planData;
    const dayCount = schedule.length;
    const placeCount = schedule.reduce((sum, day) => {
        return sum + (Array.isArray(day?.places) ? day.places.length : 0);
    }, 0);

    // 첫 번째 일자의 장소 미리보기 (최대 3개)
    const previewPlaces = schedule.length > 0 && Array.isArray(schedule[0]?.places)
        ? schedule[0].places.slice(0, 3)
        : [];

    return (
        <div className={styles.container}>
            {/* 헤더 */}
            <div className={styles.header}>
                <div className={styles.iconWrapper}>
                    <span className={styles.icon}>🗺️</span>
                </div>
                <div className={styles.headerText}>
                    <span className={styles.badge}>AI 여행 일정</span>
                    <span className={styles.creator}>{senderName}님이 생성</span>
                </div>
            </div>

            {/* 제목 */}
            <h3 className={styles.title}>{title || '새로운 여행 계획'}</h3>

            {/* 요약 정보 */}
            <div className={styles.summary}>
                {dayCount > 0 && (
                    <span className={styles.summaryItem}>
                        <span className={styles.summaryIcon}>📅</span>
                        {dayCount}일 일정
                    </span>
                )}
                {placeCount > 0 && (
                    <span className={styles.summaryItem}>
                        <span className={styles.summaryIcon}>📍</span>
                        {placeCount}곳 방문
                    </span>
                )}
            </div>

            {/* 장소 미리보기 */}
            {previewPlaces.length > 0 && (
                <div className={styles.preview}>
                    <div className={styles.previewLabel}>Day 1 미리보기</div>
                    <div className={styles.placeTags}>
                        {previewPlaces.map((place, idx) => (
                            <span key={idx} className={styles.placeTag}>
                                {place?.name || '장소'}
                            </span>
                        ))}
                        {schedule[0]?.places?.length > 3 && (
                            <span className={styles.morePlaces}>
                                +{schedule[0].places.length - 3}
                            </span>
                        )}
                    </div>
                </div>
            )}

            {/* 펼치기/접기 일정 */}
            {isExpanded && schedule.length > 0 && (
                <div className={styles.scheduleList}>
                    {schedule.map((day, dayIdx) => (
                        <div key={dayIdx} className={styles.dayItem}>
                            <div className={styles.dayLabel}>
                                Day {day?.day ?? dayIdx + 1}
                            </div>
                            <div className={styles.dayPlaces}>
                                {Array.isArray(day?.places) && day.places.map((place, pIdx) => (
                                    <span key={pIdx} className={styles.placeChip}>
                                        {place?.name}
                                    </span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* 액션 버튼ㅇ */}
            <div className={styles.actions}>
                <button
                    type="button"
                    className={styles.toggleBtn}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    {isExpanded ? '접기 ▲' : '일정 펼치기 ▼'}
                </button>
                <button
                    type="button"
                    className={styles.viewBtn}
                    onClick={onViewDetail}
                >
                    일정 관리에서 보기 →
                </button>
            </div>
        </div>
    );
};

export default AiPlanBubble;
